'use client';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  i18nManager,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from '@/infrastructure/persistence/managers/I18nManager';

export function useLanguage() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language as SupportedLanguage;

  const changeLanguage = useCallback((lang: SupportedLanguage) => {
    i18nManager.setLanguage(lang);
  }, []);

  return {
    currentLanguage,
    changeLanguage,
    supportedLanguages: SUPPORTED_LANGUAGES,
  };
}
